/**
 * TrendModa — Sticky Sepete Ekle Butonu
 * Doğrudan /cart/add.js AJAX çağrısı yapar; form submit zincirini atlar.
 * Hız: anında loading state → section render → drawer açılış
 */
(function () {
  'use strict';

  function init() {
    var stickyCart = document.querySelector('.product__sticky-cart');
    if (!stickyCart) return;

    var stickyBtn = stickyCart.querySelector('.product__sticky-cart-button');
    if (!stickyBtn) return;

    // Ana ürün formu
    var mainForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (!mainForm) return;

    // Always show the sticky bar
    stickyCart.classList.add('sticky-cart--visible');

    var originalHTML = stickyBtn.innerHTML;
    var busy = false;

    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;

      const pInfo = stickyBtn.closest('product-info');
      if (pInfo && typeof pInfo.submitForm === 'function') {
        pInfo.submitForm();
      } else if (mainForm) {
        const submitBtn = mainForm.querySelector('[name="add"]');
        if (submitBtn) submitBtn.click();
      }
    });

    // ----- Header sepet sayacı -----
    function updateHeaderCount(addedQty) {
      var countEl = document.querySelector('.ty-header__cart-count, #cart-count');
      if (!countEl) return;
      var current = parseInt(countEl.textContent, 10) || 0;
      var newCount = current + addedQty;
      countEl.textContent = newCount;

      // Standart Dawn cart-count-bubble
      var bubbleNum = document.querySelector('.cart-count-bubble span[aria-hidden]');
      if (bubbleNum) bubbleNum.textContent = newCount;
    }

    // ----- Durum yardımcıları -----
    function setState(state, msg) {
      stickyBtn.classList.remove('satc-loading', 'satc-success', 'satc-error');

      if (state === 'loading') {
        busy = true;
        stickyBtn.classList.add('satc-loading');
        stickyBtn.innerHTML =
          '<div class="sticky-btn-top">' +
          '<span class="satc-spinner" aria-hidden="true"></span>' +
          'Ekleniyor…</div>';
      } else if (state === 'success') {
        stickyBtn.classList.add('satc-success');
        stickyBtn.innerHTML =
          '<div class="sticky-btn-top">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="margin-right:8px"><polyline points="20 6 9 17 4 12"/></svg>' +
          'Sepete Eklendi!</div>';
      } else if (state === 'error') {
        stickyBtn.classList.add('satc-error');
        stickyBtn.innerHTML =
          '<div class="sticky-btn-top">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:6px"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>' +
          (msg || 'Hata') + '</div>';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
